import React from "react";
import { SideDrawer } from "../../../atoms/SideDrawer";
import { Spinner } from "../../../atoms/Spinner";

interface MessageContentDrawerProps {
  open: boolean;
  onClose: () => void;
  title: string;
  isLoading: boolean;
  data: Record<string, any> | undefined | null;
}

const isObject = (v: any) => v !== null && typeof v === "object";

const MessageContentDrawer: React.FC<MessageContentDrawerProps> = ({
  open,
  onClose,
  title,
  isLoading,
  data,
}) => {
  const entries = data ? Object.entries(data) : [];
  const scalars = entries.filter(([, v]) => !isObject(v));
  const objects = entries.filter(([, v]) => isObject(v));

  return (
    <SideDrawer open={open} onClose={onClose} title={title}>
      <div className="space-y-4 p-1">
        {isLoading ? (
          <div className="flex items-center gap-2 p-4 text-gray-500">
            <Spinner size="sm" /> Loading…
          </div>
        ) : !data ? (
          <p className="text-sm text-gray-500">No content available.</p>
        ) : (
          <>
            <dl className="divide-y divide-gray-100">
              {scalars.map(([key, value]) => (
                <div key={key} className="flex gap-3 py-2 text-sm">
                  <dt className="w-40 shrink-0 text-gray-500">{key}</dt>
                  <dd className="break-all text-gray-800">
                    {value === null || value === "" ? "—" : String(value)}
                  </dd>
                </div>
              ))}
            </dl>
            {objects.map(([key, value]) => (
              <div key={key}>
                <span className="mb-1 block text-xs font-medium uppercase text-gray-500">
                  {key}
                </span>
                <pre className="overflow-x-auto whitespace-pre-wrap break-all rounded-lg border border-gray-200 bg-gray-50 p-3 text-xs text-gray-700">
                  {JSON.stringify(value, null, 2)}
                </pre>
              </div>
            ))}
          </>
        )}
      </div>
    </SideDrawer>
  );
};

export default MessageContentDrawer;
